import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { useChatStore } from '../stores/chatStore'
import { socketService } from '../services/socketService'

const ProtectedRoute = () => {
  const { isAuthenticated } = useAuthStore()
  const initialize = useChatStore((state) => state.initialize)
  const location = useLocation()

  // Depends on isAuthenticated only: access-token refreshes must not tear the socket down.
  // The socket reads the latest token itself on every reconnect.
  useEffect(() => {
    if (!isAuthenticated) return

    socketService.connect()
    initialize()

    return () => {
      socketService.disconnect()
    }
  }, [isAuthenticated, initialize])

  if (!isAuthenticated) {
    // Remember where the agent was going (e.g. /chat?session=<id> from the email link)
    return <Navigate to="/signin" replace state={{ from: location }} />
  }

  return <Outlet />
}

export default ProtectedRoute
